<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.7 10.51">
		<polygon points="4.16 9.78 12.7 0.67 11.96 0 3.47 9.05 0.7 6.09 0 6.81 3.46 10.51 3.64 10.33 3.64 10.33 3.73 10.24 4.17 9.79 4.16 9.78" style="fill: #111"/>
	</svg>
</template>